<template>
  <div :class="byMe ? 'by-me' : ''">
    <div
      :class="`message ${hasReply ? 'has-reply' : ''}`"
      @click="replyToThis()"
    >
      <span class="username" v-show="usernameShow">{{ byWho }}</span>
      <w-d-text :text="text" />
      <span class="reply" v-if="replyText">{{ replyText }}</span>
    </div>
  </div>
</template>

<script>
import WDText from "./WDText.vue";
export default {
  name: "WMessage",
  components: { WDText },
  props: ["text", "replyText", "byWho"],
  data() {
    return {
      usernameShow: false,
      byMe: false,
      hasReply: false,
    };
  },
  beforeMount() {
    if (this.byWho === "me") {
      this.byMe = true;
    }
    if (this.byWho !== "me" && this.room_name !== "") {
      // we eed room ame pass here
      this.usernameShow = true;
    }
    if (this.replyText && this.replyText !== "") {
      this.hasReply = true;
    }
  },
  methods: {
    replyToThis() {
      this.$emit("set-replytext", this.text);
    },
  },
};
</script>

<style lang="scss" scoped>
.by-me {
  direction: rtl;
  .message {
    direction: ltr;
    --chat-message-background: var(--accent);
    --chat-reply-background: var(--tent-strong);
    --chat-reply-color: var(--accent);

    .reply {
      left: auto;
      right: 0;
    }
  }
}

.message {
  position: relative;
  color: white;
  background-color: var(--chat-message-background);
  width: fit-content;
  border-radius: 20px;
  width: fit-content;
  max-width: 60vw;
  border-radius: 12px;
  margin: 8px;
  padding: 10px 14px;
  word-wrap: break-word;
  text-align: left;

  .username {
    font-weight: bold;
    display: none;
    &.username-show {
      display: block;
    }
  }

  &.has-reply {
    margin-top: 44px;
  }

  .reply {
    z-index: -1;
    position: absolute;
    top: 0;
    left: 0;
    font-size: 0.92em;
    width: fit-content;
    max-width: 60vw;
    height: calc(100% + 34px);
    padding: 8px;
    background-color: var(--chat-reply-background);
    color: var(--chat-reply-color);
    transform: translateY(-34px);
    border-radius: 12px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  p {
    margin: 4px 0;
    width: fit-content !important;
    margin: 0 !important;
  }
}
</style>
